import React, { useRef } from 'react';

import Main from 'Elements/Main';
import Section from 'Elements/Section';
import { useTheme } from 'styled-components';

import Grid, { Col } from 'Components/Grid';
import Breadcrumbs, { BreadcrumbsProps } from 'Components/Breadcrumbs';

import MakeWavesHeroBanner, { MakeWavesHeroBannerProps } from 'Modules/HeroBanner/MakeWaves';
import SolentStories, { SolentStoriesListingFilterProps } from 'Modules/Filters/SolentStories';
import SolentStory, { SolentStoryCardProps } from 'Components/Card/SolentStory';
import { PaginationProps } from 'Components/Pagination';
import { PaginationWrapper, StyledPagination } from 'Modules/Listing/Course/Course.styled';
import FlexBox from 'Elements/FlexBox';

export interface Props {
    breadcrumbs: BreadcrumbsProps;
    heroBanner: MakeWavesHeroBannerProps;
    pagination: PaginationProps;
    filters: SolentStoriesListingFilterProps;
    results: SolentStoryCardProps[];
}

const Listing: React.FC<Props> = props => {
    const { breadcrumbs, heroBanner, results, pagination, filters } = props;
    const { colors } = useTheme();
    const listingRef = useRef() as React.MutableRefObject<HTMLDivElement>;

    return (
        <Main>
            <Breadcrumbs {...breadcrumbs} />
            <MakeWavesHeroBanner
                {...heroBanner}
                backgroundColour={colors.campaigns.clearing.secondary.hex}
            />
            <SolentStories {...filters} />
            <div ref={listingRef}>
                <Section
                    background
                    backgroundColor={colors.campaigns.clearing.secondary.hex}
                    shape="box"
                    id="listing"
                    paddingTop={1}
                >
                    <Grid>
                        <Col>
                            <FlexBox
                                cols={{ small: 1, medium: 2, xlarge: 3 }}
                                gap="1.5rem"
                                wrap="wrap"
                                asHtmlElement="ul"
                            >
                                {results.length > 0 ? (
                                    results.map(item => (
                                        <li key={item.id}>
                                            <SolentStory {...item} />
                                        </li>
                                    ))
                                ) : (
                                    <span style={{ color: 'white' }}>
                                        The filters you’ve selected do not match any stories.
                                    </span>
                                )}
                            </FlexBox>
                            {results.length > 0 && (
                                <PaginationWrapper>
                                    <StyledPagination {...pagination} />
                                </PaginationWrapper>
                            )}
                        </Col>
                    </Grid>
                </Section>
            </div>
        </Main>
    );
};

export default Listing;
